import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import config from "../config";
import { getToken } from "../utils/clerk";
import { getNativeFetch } from "../utils/nativeFetch";

export const prepareHeaders = async (headers: Headers): Promise<Headers> => {
  // Get a fresh token from Clerk for each request
  const token = await getToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  headers.set("Content-Type", "application/json");
  return headers;
};

export const baseQuery = fetchBaseQuery({
  baseUrl: config.api,
  prepareHeaders,
  fetchFn: getNativeFetch(),
});
